export function useFormat() {
  const { d: i18nD, n: i18nN, locale } = useI18n()

  function d(value: number, format: string = 'short'): string {
    if (!value) return ''
    const date = new Date(value * 1000)
    return i18nD(date, format)
  }

  function c(value: number, currency: string = 'VND', options?: Intl.NumberFormatOptions): string {
    if (value == null) return ''
    const defaultOptions: Intl.NumberFormatOptions = {
      style: 'currency',
      currency,
      maximumFractionDigits: currency === 'VND' ? 0 : 2,
      ...options
    }
    return new Intl.NumberFormat(locale.value, defaultOptions).format(value)
  }

  return { d, n: i18nN, c }
}
